export const TAGS_LOAD = 'TAGS_LOAD';
export const TAGS_LOAD_SUCCESS = 'TAGS_LOAD_SUCCESS';
export const TAGS_LOAD_ERROR = 'TAGS_LOAD_ERROR';
export const TAGS_CLEAR = 'TAGS_CLEAR';
export const TAGS_SAVE_SUCCESS = 'TAGS_SAVE_SUCCESS';
export const TAG_LOAD = 'TAG_LOAD';
export const TAG_LOAD_SUCCESS = 'TAG_LOAD_SUCCESS';
export const TAG_LOAD_ERROR = 'TAG_LOAD_ERROR';
export const TAGS_UPDATE_SUCCESS = 'TAGS_UPDATE_SUCCESS';
export const TAGS_UPDATE_ERROR = 'TAGS_UPDATE_ERROR';
export const TAGS_DELETE_ERROR = 'TAGS_DELETE_ERROR';
export const TAG_CREATE_SUCCESS = 'TAG_CREATE_SUCCESS';
export const TAG_CREATE_ERROR = 'TAG_CREATE_ERROR';
export const TAGS_DELETE_SUCCESS = 'TAGS_DELETE_SUCCESS';

export const TAG_DTO_LOAD_SUCCESS = 'TAG_DTO_LOAD_SUCCESS';
export const TAGS_DTO_LOAD_SUCCESS = 'TAGS_DTO_LOAD_SUCCESS';
export const TAGS_DTO_UPDATE_SUCCESS = 'TAGS_DTO_UPDATE_SUCCESS';